<!-- 配额酒制票通知单-->
<template>
  <div v-loading="loading" class="page-form page-base">
    <h3 class="title">{{ title }}</h3>
    <div class="form-container">
      <errors-list :errors="errorList" />
      <div class="tools">
        <template v-if="isApply">
          <form-button
            name="提交"
            @click="changeStatus('SUBMIT')"
          />
        </template>
        <template v-if="!isApply">
         <form-button name="返回" @click="$router.go(-1)" />
         <form-button v-if="buttonShow.reject" name="驳回" @click="changeStatus('REJECT')"  />
         <form-button v-if="buttonShow.cancel" name="取消" @click="changeStatus('CANCEL')"  />
        </template>
      </div>
      <el-form
        ref="form"
        inline
        size="mini"
        label-width="160px"
        :model="conditions"
        :show-message="false"
      >
        <common-title title="原票信息" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="红冲发票单号" class="line-16">
              <el-input v-model="conditions.red_rush_id" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="old_invo_infoid" label="原制票通知单号" :disabled="!isApply">
              <wly-input
                v-if="isApply"
                v-model="conditions.old_invo_infoid"
                input-type="makeTicket"
                @enter="handleEnter"
                @handleSuffixClick="openSelectDialog($event, 'client')"
              />
              <el-input
                v-else
                v-model="conditions.old_invo_infoid"
                disabled
                size="mini"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="原外部制票通知单号" class="line-16">
              <el-input v-if="isApply" v-model="conditions.w_invo_infoid" disabled />
              <el-input
                v-else
                v-model="conditions.old_w_invo_infoid"
                disabled
                size="mini"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="制票通知单类型" class="line-16">
              <el-select v-if="isApply" v-model="conditions.inf_type" placeholder="" disabled>
                <el-option
                  v-for="item in selectDataOptions['A0022']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
              <el-input
                v-else
                v-model="conditions.old_inf_type_text"
                disabled
                size="mini"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="开票客户编码">
              <el-input v-model="conditions.customer" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="开票客户名称">
              <el-input v-model="conditions.cust_name" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="开票日期">
              <el-date-picker
                v-if="isApply"
                v-model="conditions.mak_date"
                disabled
                type="date"
                value-format="yyyyMMdd"
              />
              <el-input
                v-else
                v-model="conditions.old_mak_date"
                disabled
                size="mini"
              />
            </el-form-item>
          </el-col>
          <!-- <el-col :lg="8" :md="12">
            <el-form-item label="收票联系人">
              <el-input v-model="conditions.recinv_pers" disabled />
            </el-form-item>
          </el-col> -->
        </el-row>
        <!-- <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="收票联系人电话" class="line-16">
              <el-input v-model="conditions.recinv_tel" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="是否已打印">
              <el-checkbox v-model="conditions.mark_print" true-label="X" false-label="" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="发票类型">
              <el-select v-model="conditions.inv_type" placeholder="" disabled>
                <el-option
                  v-for="item in selectDataOptions['A0032']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row :gutter="24">
          <!-- <el-col :lg="8" :md="12">
            <el-form-item label="换票日期">
              <el-input v-model="conditions.chan_date" disabled />
            </el-form-item>
          </el-col> -->

          <el-col :lg="8" :md="12">
            <el-form-item label="发票金额">
              <el-input v-if="isApply" v-model="conditions.inv_amount" disabled />
               <el-input
                v-else
                v-model="conditions.old_inv_amount"
                disabled
                size="mini"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="红票信息" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="红票制票通知单号">
              <el-input v-model="conditions.red_invo_infoid" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label=" 红票外部制票通知单号">
              <el-input v-model="conditions.red_w_invo_infoid" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="红票开票日期">
              <el-date-picker
                v-model="conditions.red_mak_date"
                disabled
                type="date"
                value-format="yyyyMMdd"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="红票发票总金额">
              <el-input v-model="conditions.red_inv_amount" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="蓝票信息" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="蓝票制票通知单号">
              <el-input v-model="conditions.blue_invo_infoid" disabled />
            </el-form-item>
          </el-col>
           <el-col :lg="8" :md="12">
            <el-form-item label=" 蓝票外部制票通知单号">
              <el-input v-model="conditions.blue_w_invo_infoid" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="蓝票开票日期">
              <el-date-picker
                v-model="conditions.blue_mak_date"
                disabled
                type="date"
                value-format="yyyyMMdd"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="蓝票发票总金额">
              <el-input v-model="conditions.blue_inv_amount" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="状态" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="创建人">
              <el-input v-model="conditions.uname" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="创建日期">
              <el-date-picker
                v-model="conditions.datum"
                disabled
                type="date"
                value-format="yyyyMMdd"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="状态">
              <el-select v-model="conditions.status_text" placeholder="" disabled>
                <el-option
                  v-for="item in selectDataOptions['A0033']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <common-title title="区域" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="营销单元">
              <el-input v-model="conditions.zzfld000001_text" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="基地">
              <el-input v-model="conditions.zzfld00003e" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="省区">
              <el-input v-model="conditions.zzfld000002_text" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="城市">
              <el-input v-model="conditions.zzfld000003_text" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="业务员">
              <el-input v-model="conditions.zzfld000004_dscr" disabled />
            </el-form-item>
          </el-col>
        </el-row> -->
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon title="原行项目" :custome-config="() => vxeShowCustom('gridOptions')">
        <vxe-grid
          ref="gridOptions"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :cell-class-name="cellClassName"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        >
          <template #warehouse="{ row }">
            <el-select v-model="row.warehouse" size="mini" disabled>
              <el-option
                v-for="item in selectDataOptions['A0039']"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              />
            </el-select>
          </template>
        </vxe-grid>
      </TableCommon>

      <TableCommon title="红票" :custome-config="() => vxeShowCustom('gridRedOptions')" v-if="!isApply">
        <vxe-grid
          ref="gridRedOptions"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :cell-class-name="cellClassName"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridRedOptions.columns"
          :data="gridRedOptions.data"
        >
          <template #warehouse="{ row }">
            <el-select v-model="row.warehouse" size="mini" disabled>
              <el-option
                v-for="item in selectDataOptions['A0039']"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              />
            </el-select>
          </template>
        </vxe-grid>
      </TableCommon>

      <TableCommon title="蓝票" :custome-config="() => vxeShowCustom('gridBlueOptions')" v-if="!isApply">
        <vxe-grid
          ref="gridBlueOptions"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :cell-class-name="cellClassName"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridBlueOptions.columns"
          :data="gridBlueOptions.data"
        >
          <template #warehouse="{ row }">
            <el-select v-model="row.warehouse" size="mini" disabled>
              <el-option
                v-for="item in selectDataOptions['A0039']"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              />
            </el-select>
          </template>
        </vxe-grid>
      </TableCommon>

      <TableCommon title="状态变更记录" :custome-config="() => vxeShowCustom('gridOptionsHistory')">
        <vxe-grid
          ref="gridOptionsHistory"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsHistory.columns"
          :data="gridOptionsHistory.data"
        />
      </TableCommon>
    </div>

    <el-dialog
      v-dialogDrag
      :visible.sync="showDialog"
      title="原制票通知单号选择"
      width="70%"
      top="5vh"
    >
      <template v-if="showDialog">
        <invoiceDetailQuery ref="dialogEdit"/>
      </template>
      <div slot="footer">
        <el-button
          type="default"
          icon="el-icon-circle-close"
          size="small"
          @click="showDialog = false"
        >取消</el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-check"
          size="small"
          @click="submitHandle"
        >确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { apiRedSubmit, apiGetDetailById, apiGetRedRushId, apiReSend, apiCreateNext, printInvoice } from '@/api/sap/make-invoice-sap'
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { mapGetters, mapState } from 'vuex'
import invoiceDetailQuery from './components/invoiceDetailQuery'
// import invoiceDetailQuery from './invoiceDetailQuery'
export default {
  components: {
    invoiceDetailQuery
  },
  data() {
    return {
      loading: false,
      showDialog: false,
      conditions: {},
      mesid_kp: '',
      mesid_zzc: '',
      isNew: false,
      errorList: [],
      selectDataOptions: {},
      gridOptions: {
        columns: [
          { field: 'ordered_prod', title: '产品编号', width: 120 },
          { field: 'description', title: '产品描述', width: 120 },
          { field: 'zzfld00002s', title: '规格型号', width: 120 },
          { field: 'use_quantity', title: '开票数量', width: 120 },
          { field: 'use_zzfld9', title: '开票件数', width: 80 },
          { field: 'use_bot', title: '开票瓶数', width: 80 },
          { field: 'zzfld00002t', title: '单位', width: 80 },
          { field: 'zzfld00002e', title: '税率', width: 80 },
          { field: 'net_price', title: '含税单价', width: 120 },
          { field: 'net_value', title: '价税合计', width: 120 },
          // { field: 'zzfld00002a', title: '折扣类型', width: 120 },
          { field: 'zzfld00002a_text', title: '折扣类型', width: 120 },
          { field: 'zzfld00002f', title: '单品折扣', width: 120 },
          { field: 'zzfld00002g', title: '折后含税单价', width: 120 },
          { field: 'zzfld00002i', title: '折扣额', width: 120 },
          { field: 'object_id', title: '销售订单号', width: 120 },
          { field: 'number_int', title: '销售订单号行项目', width: 150 },
          { field: 'cust_name', title: '订单客户', width: 120 },
          { field: 'reward_type_text', title: '奖励类型', width: 120 },
          { field: 'reward_number', title: '奖励编号', width: 120 },
          { field: 'reward_name', title: '项目/计划编号', width: 120 },
          { field: 'send_qty', title: '已发运件数', width: 120 },
          { field: 'guaranty', title: '随货保证金', width: 120 },
          { field: 'invo_id', title: '发票号', width: 120 },
          { field: 'manual_invo', title: '提货票', width: 120 },
          { field: 'warehouse', title: '仓库', width: 120, slots: { default: 'warehouse' }, params: { bgEdit: true }},
          { field: 'remark', title: '备注', width: 120 },
          { field: 'deliver_qty', title: '要货已审核量', width: 120 },
          { field: 'zc_deliver_qty', title: '总仓出库量', width: 120 },
          { field: 'fc_deliver_qty', title: '分仓出库量', width: 120 },

        ],
        data: []
      },
      gridRedOptions: {
        columns: [
          { field: 'ordered_prod', title: '产品编号', width: 120 },
          { field: 'description', title: '产品描述', width: 120 },
          { field: 'zzfld00002s', title: '规格型号', width: 120 },
          { field: 'use_quantity', title: '开票数量', width: 120 },
          { field: 'use_zzfld9', title: '开票件数', width: 80 },
          { field: 'use_bot', title: '开票瓶数', width: 80 },
          { field: 'zzfld00002t', title: '单位', width: 80 },
          { field: 'zzfld00002e', title: '税率', width: 80 },
          { field: 'net_price', title: '含税单价', width: 120 },
          { field: 'net_value', title: '价税合计', width: 120 },
          // { field: 'zzfld00002a', title: '折扣类型', width: 120 },
          { field: 'zzfld00002a_text', title: '折扣类型', width: 120 },
          { field: 'zzfld00002f', title: '单品折扣', width: 120 },
          { field: 'zzfld00002g', title: '折后含税单价', width: 120 },
          { field: 'zzfld00002i', title: '折扣额', width: 120 },
          { field: 'object_id', title: '销售订单号', width: 120 },
          { field: 'number_int', title: '销售订单号行项目', width: 150 },
          { field: 'cust_name', title: '订单客户', width: 120 },
          { field: 'reward_type_text', title: '奖励类型', width: 120 },
          { field: 'reward_number', title: '奖励编号', width: 120 },
          { field: 'reward_name', title: '项目/计划编号', width: 120 },
          { field: 'send_qty', title: '已发运件数', width: 120 },
          { field: 'guaranty', title: '随货保证金', width: 120 },
          { field: 'invo_id', title: '发票号', width: 120 },
          { field: 'manual_invo', title: '提货票', width: 120 },
          { field: 'warehouse', title: '仓库', width: 120, slots: { default: 'warehouse' }, params: { bgEdit: true }},
          { field: 'remark', title: '备注', width: 120 },
        ],
        data: []
      },
      gridBlueOptions: {
        columns: [
          { field: 'ordered_prod', title: '产品编号', width: 120 },
          { field: 'description', title: '产品描述', width: 120 },
          { field: 'zzfld00002s', title: '规格型号', width: 120 },
          { field: 'use_quantity', title: '开票数量', width: 120 },
          { field: 'use_zzfld9', title: '开票件数', width: 80 },
          { field: 'use_bot', title: '开票瓶数', width: 80 },
          { field: 'zzfld00002t', title: '单位', width: 80 },
          { field: 'zzfld00002e', title: '税率', width: 80 },
          { field: 'net_price', title: '含税单价', width: 120 },
          { field: 'net_value', title: '价税合计', width: 120 },
          // { field: 'zzfld00002a', title: '折扣类型', width: 120 },
          { field: 'zzfld00002a_text', title: '折扣类型', width: 120 },
          { field: 'zzfld00002f', title: '单品折扣', width: 120 },
          { field: 'zzfld00002g', title: '折后含税单价', width: 120 },
          { field: 'zzfld00002i', title: '折扣额', width: 120 },
          { field: 'object_id', title: '销售订单号', width: 120 },
          { field: 'number_int', title: '销售订单号行项目', width: 150 },
          { field: 'cust_name', title: '订单客户', width: 120 },
          { field: 'reward_type_text', title: '奖励类型', width: 120 },
          { field: 'reward_number', title: '奖励编号', width: 120 },
          { field: 'reward_name', title: '项目/计划编号', width: 120 },
          { field: 'send_qty', title: '已发运件数', width: 120 },
          { field: 'guaranty', title: '随货保证金', width: 120 },
          { field: 'invo_id', title: '发票号', width: 120 },
          { field: 'manual_invo', title: '提货票', width: 120 },
          { field: 'warehouse', title: '仓库', width: 120, slots: { default: 'warehouse' }, params: { bgEdit: true }},
          { field: 'remark', title: '备注', width: 120 },
        ],
        data: []
      },
      gridOptionsHistory: {
        columns: [
          { field: 'operationer', title: '操作员' },
          { field: 'oper_name', title: '操作姓名' },
          // { field: 'oper_status', title: '操作状态' },
          { field: 'status_text', title: '操作状态' },
          { field: 'changin_date', title: '变更日期' },
          { field: 'changin_time', title: '变更时间' }
        ],
        data: []
      },
      isApply: true, // 是否是制票申请
      buttonShow: {
        submit: '', // 提交
        reject: '', // 驳回
        cancel: '', // 取消
      },
    }
  },
  computed: {
    ...mapState('user', ['userInfo']),
    ...mapGetters(['role']),
    title() {
      if (this.selectDataOptions?.A0022 && this.conditions?.inf_type) {
        return this.selectDataOptions['A0022'].find(v => v.value === this.conditions.inf_type).name
      } else {
        return '制票通知单'
      }
    }
  },
  created() {
    this.getSelectDictDataOrigin('A0022')
    this.getSelectDictDataOrigin('A0032')
    this.getSelectDictDataOrigin('A0033')
    this.getSelectDictDataOrigin('A0039')
    const { id } = this.$route.query
    if (id) {
      // 如果有id那么就是查询页面进来的，需要调用查询接口
      this.getRedOrderDetail(id)
    }
  },
  methods: {
    // 控件回车
    async handleEnter(e, type, data, row, mode) {
      // console.log('handleEnter', type, data)
      if (typeof type === 'object') {
        this.errorList && (this.errorList = [type.message])
        return
      }
      if (!data) return
      this.conditions = data.head
      this.conditions.old_invo_infoid =  data.head.invo_infoid
      // this.gridOptionsHistory.data = data.history
      this.gridOptions.data = data.item
      this.conditions.inv_status = 'E001'
      this.conditions.datum = new Date()
    },
    // 打开窗口
    openSelectDialog(e, type, row = {}, mode) {
      e.target.blur()
      this.showDialog = true
    },
    cellClassName({ column }) {
      return column.params?.bgEdit ? 'cell--bg--edit' : 'cell--bg--default'
    },
     // 弹窗内的方法这边来处理，方便数据回调在本页面处理
    submitHandle() {
      this.$refs.dialogEdit.submitForm().then(async res => {
        res.invo_infoid && this.selectZhiPiao(res)
        this.showDialog = false
      })
    },
    selectZhiPiao(res){
      this.getDetail(res.invo_infoid)
    },
    async changeStatus(mode) {
      this.loading = true
      const params = {
        mode,
        user_bp: this.role.USER_BP,
        role: this.role.ROLE,
        head: { ...this.conditions,old_invo_infoid: this.conditions.invo_infoid, },
        red_rush_id: '',
      }
      this.errorList = []
      try {
        const result = await apiRedSubmit(params)
        if (result.msgtype === 'S') {
          this.$message.success(result.message)
          await this.getRedOrderDetail(result.data)
        } else {
          this.loading = false
          this.errorList.push(result.message)
        }
      } catch (e) {
        this.loading = false
      }
    },
    async getRedOrderDetail(id) {
      this.loading = true
      this.isApply = false
      const {data} = await apiGetRedRushId({'red_rush_id': id })
      this.conditions = data.head
      this.conditions.red_mak_date  = this.conditions.red_mak_date == '00000000' ? '' : this.conditions.red_mak_date
      this.conditions.blue_mak_date = this.conditions.blue_mak_date == '00000000' ? '' : this.conditions.blue_mak_date
      this.gridOptionsHistory.data = data.history
      this.gridOptions.data = data.old_item
      this.gridRedOptions.data = data.red_item
      this.gridBlueOptions.data = data.blue_item
      this.buttonShow = data.button
      this.loading = false
    },
    async getDetail(id) {
      this.loading = true
      const { data, additional, msgtype, message } = await apiGetDetailById({ mode: 'RED_RUSH', INVO_INFOID: id })
      if(msgtype === 'E') {
        this.$message.error(message)
        this.loading = false
        return
      }
      this.mesid_zzc = data.mesid_zzc
      this.mesid_kp = data.mesid_kp
      this.conditions = data.head
      this.conditions.old_invo_infoid =  data.head.invo_infoid
      this.conditions.zzfld00003e = additional
      // this.gridOptionsHistory.data = data.history
      this.gridOptions.data = data.item
      this.conditions.inv_status = 'E001'
      this.conditions.datum = new Date()
      this.loading = false
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/invoice-manage/redOrderApply.vue